// ERROR_CODES
export const AUTHORIZATION_PASSWORD_FORGOTTEN_CODE = "AADB2C90118";
export const AUTHORIZATION_PASSWORD_FORGOTTEN_CANCELED_CODE = "AADB2C90091";
